import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a73dd0cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sample-content-modal" }
const _hoisted_2 = {
  key: 0,
  id: "column-modal"
}
const _hoisted_3 = { class: "modal-window" }
const _hoisted_4 = { class: "sample-content-modal-content" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "summary" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "sample-content-modal-btn" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("a", {
      class: "link",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleModal && _ctx.toggleModal(...args)))
    }, "プレビュー"),
    (_ctx.isShowModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "modal modal-overlay",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleModal && _ctx.toggleModal(...args)))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.sampleTemplate.title), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.sampleTemplate.summary), 1),
                _createElementVNode("pre", _hoisted_7, _toDisplayString(_ctx.sampleTemplate.content), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("a", {
                  class: "download-btn",
                  href: _ctx.downloadUrl
                }, "ダウンロード", 8, _hoisted_9),
                _createElementVNode("a", {
                  class: "create-btn",
                  href: _ctx.createArticleUrl
                }, "プレスリリース作成", 8, _hoisted_10)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}